import React from "react";
import Button from "@mui/material/Button";
import { ArrowDownward, ArrowUpward } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import SearchByType from "@_components/SearchByType/SearchByType";
import { caseConstants } from "@_constants/case.constants";
import ActiveFilterButton from "./ActiveFilterButton";
import CasesFilterMenu from "./CasesFilterMenu";
import styles from "../Cases.module.css";

function CasesToolbar({
  searchValue,
  selectedSearchTag,
  casesSearchTag,
  onSearchInputChange,
  onSearchTagSelect,
  onClearClick,
  ascending,
  onSortToggle,
  onExport,
  onAddCase,
  activeFilter,
  onFilterIconClicked,
  filterCount,
  filterMenuOpen,
  onActivateFilter,
  onCloseFilterMenu,
}) {
  return (
    <>
      <div className={styles.search_case_container}>
        <SearchByType
          label={"Search"}
          searchValue={searchValue}
          selectedSearchTag={selectedSearchTag}
          casesSearchTag={casesSearchTag}
          onSearchInputChange={onSearchInputChange}
          onSearchTagSelect={onSearchTagSelect}
          onClearClick={onClearClick}
          inputProps={{ "data-testid": "cases-toolbar-search-field" }}
        />
      </div>
      <div className={styles.bottom_cases_options}>
        <span>Sort order: </span>
        <span
          className={styles.sort_icon_container}
          data-testid="cases-toolbar-sort-btn"
          onClick={onSortToggle}
        >
          {ascending ? (
            <ArrowUpward fontSize="small" />
          ) : (
            <ArrowDownward fontSize="small" />
          )}
        </span>
        <Tooltip title="Download Cases Report">
          <span
            className={styles.case_report_icon}
            onClick={onExport}
            data-testid="cases-toolbar-export-btn"
          >
            Export
          </span>
        </Tooltip>
      </div>
      <div className={styles.add_case_container}>
        <div className={styles.cases_top_container}>
          <div className={styles.add_case_button}>
            <Button
              onClick={onAddCase}
              variant="outlined"
              data-testid="cases-toolbar-add-case-btn"
            >
              Add New Case
            </Button>
          </div>
        </div>
        <div className={styles.filter_container}>
          <div>
            <ActiveFilterButton
              activeFilter={activeFilter}
              onClick={onFilterIconClicked}
            />
          </div>
          {(activeFilter !== caseConstants.CASE_FILTER_NONE || searchValue) && (
            <div
              className={styles.filter_counter}
              data-testid="cases-toolbar-filter-count"
            >
              {filterCount}
            </div>
          )}
        </div>

        {filterMenuOpen && (
          <CasesFilterMenu
            onActivateFilter={onActivateFilter}
            onClose={onCloseFilterMenu}
          />
        )}
      </div>
    </>
  );
}

export default CasesToolbar;
